module.exports = __webpack_public_path__ + "img/up1.dc339bba.png";